import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { httpLoaderFactory } from './services/httpLoaderFactory';
import { EmbeddedViewModule } from './embedded-view/embedded-view.module';
import { BootstrapServicesComponent } from './bootstrap-services/bootstrap-services.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AppRoutingModule } from './app-routing.module';
import { SectionModule } from './section/section.module';
import { NgService } from './core/ng.service';
import {
  AnalyticsService,
  AuthService,
  CaliperService,
  CitationListsConfigurationService,
  CitationService,
  ContainerService,
  ItemViewService,
  ListService,
  NgUtilsService,
  ShoppingCartService,
  UserService
} from './ajs-upgraded-providers';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { UpgradeModule } from '@angular/upgrade/static';

@NgModule({
  imports: [
    BrowserModule,
    UpgradeModule,
    FormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    TooltipModule.forRoot(),
    EmbeddedViewModule,
    //  SortablejsModule.forRoot({
    //    ghostClass: 'ghost',
    //    animation: 150,
    //    draggable: ".item-draggable",
    //    handle: ".item-drag-handler"
    //   }),
    AppRoutingModule,
    SectionModule,
    BrowserAnimationsModule
  ],
  providers: [
    { provide: ContainerService, useFactory: (i: any) => i.get('ContainerService'), deps: ['$injector'] },
    { provide: AuthService, useFactory: (i: any) => i.get('authService'), deps: ['$injector'] },
    { provide: ListService, useFactory: (i: any) => i.get('ListService'), deps: ['$injector'] },
    { provide: UserService, useFactory: (i: any) => i.get('UserService'), deps: ['$injector'] },
    { provide: CitationService, useFactory: (i: any) => i.get('CitationService'), deps: ['$injector'] },
    { provide: AnalyticsService, useFactory: (i: any) => i.get('AnalyticsService'), deps: ['$injector'] },
    { provide: ItemViewService, useFactory: (i: any) => i.get('ItemViewService'), deps: ['$injector'] },
    { provide: CaliperService, useFactory: (i: any) => i.get('CaliperService'), deps: ['$injector'] },
    { provide: CitationListsConfigurationService, useFactory: (i: any) => i.get('CitationListsConfigurationService'), deps: ['$injector'] },
    { provide: ShoppingCartService, useFactory: (i: any) => i.get('ShoppingCartService'), deps: ['$injector'] },
    { provide: NgUtilsService, useFactory: (i: any) => i.get('utilsService'), deps: ['$injector'] },
    NgService
  ],
  declarations: [
    BootstrapServicesComponent
  ]
})
export class AppModule {
  constructor(private _translate: TranslateService, private upgrade: UpgradeModule) {
    this._translate.setDefaultLang('en');
    this._translate.use('en');
  }

  ngDoBootstrap() {
    if (environment.isNewUI) {
      this.upgrade.bootstrap(document.getElementById('rlApp'), ['readingListApp']);
    }
  }
}
